"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membershipDefinitionFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
const util_1 = require("../../util");
const assignmentTypes = [
    'allow_paid',
    'allow_free',
    'allow_unapproved_paid',
    'allow_unapproved_free',
];
exports.membershipDefinitionFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    additional_fields: [],
    boss_organization_id: 530,
    name: 'Test Membership Definition',
    description: 'Test',
    start_date: Mocks.dates.date2000,
    end_date: Mocks.dates.date2100,
    purchase_open: Mocks.dates.date2000,
    purchase_close: Mocks.dates.date2100,
    effective_type: 'lifetime',
    clare_item_uuid: Factory.each(i => uuid_1.v4()),
    validation_rules: [],
    membership_assignment_type: Factory.each(i => util_1.rand(assignmentTypes)),
    can_invite: true,
    can_direct: true,
    can_affiliate_obo: true,
    linkable: true,
    archived_at: null,
    membership_count: 100,
    messages: [],
    purchase_status: 'published',
    is_editable: true,
    membership_definitions_credential_definitions: [],
    parent_membership_definition_id: null,
    child_membership_definition_id: null,
    parent_membership_definition_links: [],
    child_membership_definition_links: [],
});
